<template>
  <div class="ac1">
    <div class="banner">
      <img src="/imgs/b1.jpg" alt="" />
    </div>
    <div class="container">
      <!-- 标题 -->
      <div class="at-title">
        <h2>行业资讯</h2>
        <div class="title-line"></div>
      </div>

      <!-- 循环项 -->
      <div
        class="at-item"
        v-for="(item, index) in this.myData"
        :key="index"
        @click="gopay()"
      >
        <!-- 左侧图片 -->
        <div class="item-l">
          <img :src="item.img" alt="" />
          <div class="image-overlay">
            <span class="read-btn">点击阅读</span>
          </div>
        </div>
        <!-- 右侧信息 -->
        <div class="item-r">
          <!-- 标题 -->
          <div class="item-title">{{ item.title }}</div>
          <!-- 标签 -->
          <div class="item-tags">
            <span class="tag hot">热门</span>
            <span class="tag new">最新</span>
            <span class="time">5分钟前</span>
          </div>
          <!-- 文本 -->
          <p>
            {{ item.jj }}
          </p>
          <!-- 信息层 -->
          <div class="item-info">
            <div class="price-info">
              <span class="price-icon">￥</span>
              <span class="price">2元</span>
              <span class="price-text">/条</span>
            </div>
            <div class="action-btns">
              <span class="action-btn like">👍 128</span>
              <span class="action-btn comment">💬 36</span>
              <span class="action-btn share">📤 分享</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      title="请付款阅读"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img src="/imgs/pay.png" />
        <h2>微信支付</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal.vue";
export default {
  name: "ac1",
  components: {
    Modal,
  },
  data() {
    return {
      href: "index.html",
      ac1: [],
      ac2: [],
      ac3: [],
      ac: [],
      myData: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init1();
    document.title = "京游科技（北京）有限公司";
  },
  methods: {
    init1() {
      this.axios.get("/mock/ac.json").then((res) => {
        const data = res.data;
        // 咨询区块1
        this.myData = data.slice(0, 10);
      });
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      alert("资讯每条2元，点击确定购买");
      this.showModal = true;
    },
    msub() {
      this.$message.error("支付失败!");
      this.showModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac1 {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  min-height: 100vh;
  
  .banner {
    width: 100%;
    height: 320px;
    overflow: hidden;
    position: relative;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    
    &:hover img {
      transform: scale(1.02);
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 60px;
      background: linear-gradient(transparent, #f5f7fa);
    }
  }
  
  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    
    // 标题
    .at-title {
      text-align: center;
      margin-bottom: 50px;
      position: relative;
      
      h2 {
        font-size: 32px;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 15px;
        position: relative;
        display: inline-block;
        
        &::before {
          content: '✦';
          margin-right: 10px;
          color: #1890ff;
        }
        
        &::after {
          content: '✦';
          margin-left: 10px;
          color: #1890ff;
        }
      }
      
      .title-line {
        width: 80px;
        height: 3px;
        background: linear-gradient(90deg, #1890ff, #52c41a);
        margin: 0 auto;
        border-radius: 2px;
      }
    }
    
    // 循环项
    .at-item {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      margin-bottom: 24px;
      overflow: hidden;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border: 1px solid rgba(0, 0, 0, 0.05);
      display: flex;
      cursor: pointer;
      
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        
        .item-l .image-overlay {
          opacity: 1;
        }
        
        .item-title {
          color: #1890ff;
        }
      }
      
      // 左侧图片
      .item-l {
        width: 280px;
        height: 180px;
        position: relative;
        flex-shrink: 0;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
        
        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          
          .read-btn {
            color: #fff;
            padding: 10px 20px;
            border: 2px solid #fff;
            border-radius: 25px;
            font-weight: 600;
            font-size: 14px;
            transition: all 0.3s ease;
            
            &:hover {
              background: #fff;
              color: #1890ff;
            }
          }
        }
      }
      
      // 右侧
      .item-r {
        flex: 1;
        padding: 24px 32px;
        display: flex;
        flex-direction: column;
        
        // 标题
        .item-title {
          font-size: 20px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 12px;
          line-height: 1.4;
          transition: color 0.3s ease;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        // 标签
        .item-tags {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          
          .tag {
            padding: 4px 12px;
            border-radius: 15px;
            font-size: 12px;
            font-weight: 600;
            
            &.hot {
              background: #fff2e8;
              color: #fa541c;
            }
            
            &.new {
              background: #f6ffed;
              color: #52c41a;
            }
          }
          
          .time {
            font-size: 13px;
            color: #8c8c8c;
          }
        }
        
        // 文本
        p {
          font-size: 14px;
          color: #595959;
          line-height: 1.6;
          margin-bottom: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          flex: 1;
        }
        
        // 信息层
        .item-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 16px;
          border-top: 1px solid #f0f0f0;
          
          .price-info {
            display: flex;
            align-items: center;
            background: linear-gradient(135deg, #ff4d4f, #ff7a45);
            padding: 8px 16px;
            border-radius: 20px;
            color: #fff;
            
            .price-icon {
              font-size: 14px;
              margin-right: 2px;
            }
            
            .price {
              font-size: 20px;
              font-weight: 700;
              margin: 0 4px;
            }
            
            .price-text {
              font-size: 12px;
              opacity: 0.9;
            }
          }
          
          .action-btns {
            display: flex;
            gap: 20px;
            
            .action-btn {
              font-size: 13px;
              color: #8c8c8c;
              padding: 6px 12px;
              border-radius: 6px;
              transition: all 0.2s ease;
              cursor: pointer;
              
              &:hover {
                background: #f5f5f5;
                color: #1890ff;
              }
            }
          }
        }
      }
    }
  }
}

// 加载动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.at-item {
  animation: fadeInUp 0.5s ease forwards;
}

.at-item:nth-child(odd) {
  animation-delay: 0.1s;
}

.at-item:nth-child(even) {
  animation-delay: 0.2s;
}
</style>